import { useState, useRef, useEffect } from 'react';
import { parseProtocolMessage } from '../lib/helpers';

export const useDeviceState = () => {
    const [maxLoad, setMaxLoad] = useState(0);
    const [avgLoad, setAvgLoad] = useState(0);
    const [minLoad, setMinLoad] = useState(0);
    const [deviceGain, setDeviceGain] = useState(0.5);
    const [envelope0, setEnvelope0] = useState(0);
    const [envelope1, setEnvelope1] = useState(0);
    const [masterOutLeft, setMasterOutLeft] = useState(0);
    const [masterOutRight, setMasterOutRight] = useState(0);
    const [limiterGain, setLimiterGain] = useState(0);
    const [lastResponse, setLastResponse] = useState('');
    const [responseColor, setResponseColor] = useState('#888888');

    const responseTimeoutRef = useRef(null);

    const showResponse = (text, color) => {
        setLastResponse(text);
        setResponseColor(color);

        if (responseTimeoutRef.current) {
            clearTimeout(responseTimeoutRef.current);
        }

        responseTimeoutRef.current = setTimeout(() => {
            setLastResponse('');
        }, 2000);
    };

    const handleStatusMessage = (key, value) => {
        try {
            if (key === 'cpu.max') {
                setMaxLoad(parseFloat(value));
            } else if (key === 'cpu.avg') {
                setAvgLoad(parseFloat(value));
            } else if (key === 'cpu.min') {
                setMinLoad(parseFloat(value));
            } else if (key === 'synth.gain') {
                setDeviceGain(parseFloat(value));
            } else if (key === 'envelope.0') {
                setEnvelope0(parseFloat(value));
            } else if (key === 'envelope.1') {
                setEnvelope1(parseFloat(value));
            } else if (key === 'master.out.left') {
                setMasterOutLeft(parseFloat(value));
            } else if (key === 'master.out.right') {
                setMasterOutRight(parseFloat(value));
            } else if (key === 'limiter.gain') {
                setLimiterGain(parseFloat(value));
            }
        } catch (e) {
            console.error('Error parsing status message:', e);
        }
    };

    const processLine = (line) => {
        const msg = parseProtocolMessage(line);
        if (!msg) return;

        const { type, key, value } = msg;

        if (type === 'status') {
            handleStatusMessage(key, value);
        } else if (type === 'ack') {
            showResponse(`OK: ${key}`, '#4ecdc4');
        } else if (type === 'error') {
            showResponse(`ERR: ${key} (${value})`, '#ff6b6b');
        }
    };

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (responseTimeoutRef.current) {
                clearTimeout(responseTimeoutRef.current);
            }
        };
    }, []);

    return {
        maxLoad,
        avgLoad,
        minLoad,
        deviceGain,
        envelope0,
        envelope1,
        masterOutLeft,
        masterOutRight,
        limiterGain,
        lastResponse,
        responseColor,
        processLine
    };
};